<template>
  <div class="wrap">
    <Drawer title="创建工具" :visible="visible" :before-close="close" :wrapper-closable="false">
      <template v-slot:default>
        <el-form :model="form" :rules="rules" ref="form" label-position="top">
          <el-form-item label="工具名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入知识库名称"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-radio-group v-model="form.type" :disabled="type === 'edit'" @change="handleTypeChange">
              <el-radio v-for="(item, key) in AI_AGENT_TOOL_CUSTOM_TYPE" :label="key" :key='key'>{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="AI_AGENT_TOOL_CUSTOM_TYPE[form.type]" prop="reference" v-if="form.type">
            <el-select v-model="form.reference" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in toolParam"
                :key="item.reference"
                :label="item.name"
                :value="item.reference"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input type="textarea" v-model="form.description" placeholder="请输入描述"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template v-slot:footer>
        <el-button class="drawer-footer-btn" type="primary" @click="submitForm">保存</el-button>
        <el-button class="drawer-footer-btn" type="primary" @click="close">返回</el-button>
      </template>
    </Drawer>
  </div>
</template>

<script>
import Drawer from '@/components/drawer';
import { CosMixin } from '@/mixins/cos';
import {cloneDeep, merge, isNil} from 'lodash';
import {  AI_AGENT_TOOL_CUSTOM_TYPE } from '@/utils/constant';

const defaultForm = {
  name: '',
  type: '',
  description: '',
  reference: '',
};

export default {
  name: 'CreateEditTool',
  components: { Drawer },
  props: {
    row: {type: Object, default: () => {} },
    type: {type: String, default: 'create' },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [CosMixin],
  data() {
    return {
      AI_AGENT_TOOL_CUSTOM_TYPE,
      form: cloneDeep(defaultForm),
      agentTool: {},
      inputCategoryVisible: false,
      inputCategoryValue: '',
      toolParam: [],
      rules: {
        name: [
          { required: true, message: '请输入工具名称', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' },
        ],
        reference: [
          {
            validator: (rule, value, callback) => {
              if(!value) {
                callback(new Error(`请选择${AI_AGENT_TOOL_CUSTOM_TYPE[this.form.type]}`));
              } else{
                callback();
              }
            },
            trigger: 'change',
          },
          { required: true, trigger: 'change' },
        ],
      }
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        if(this.type === 'edit') {
          this.form =merge(cloneDeep(defaultForm), this.resetData(cloneDeep(this.row)));
        } else {
          this.form = cloneDeep(defaultForm);
        }
        this.getToolParam();
      }
      this.$nextTick(()=>{
        this.$refs?.form?.clearValidate();
      });
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close');
    },
    resetData(formData) {
      return formData;
    },
    handleClose(tag) {
      this.form.tags.splice(this.form.tags.indexOf(tag), 1);
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          const formData = cloneDeep(this.form);
          formData.instruction = isNil(formData.instruction) || formData.instruction === '' ? undefined : formData.instruction;
          console.log('submit data: ', formData);
          this.$request({
            url: this.type === 'edit' ? this.$api.updateAgentTool : this.$api.createAgentTool,
            data: this.type === 'edit' ? {
                    id: formData.id,
                    agent_tool: formData,
            } : {
                    agent_tool: formData,
            },
          }).then((res) => {
              console.log('%c Line:154 🥕 res', 'color:#42b983', res);
              this.$emit('refresh');
              this.$message.success('保存成功');
              this.close();
          }).catch(()=>{
              this.$message.error('保存失败');
          });
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
    async handleTypeChange() {
      this.$set(this.form, 'reference', '');
      this.$nextTick(()=>{
        this.$refs?.form?.clearValidate(['reference']);
      });
      await this.getToolParam();
    },
    async getToolParam() {
      this.toolParam = [];
      if(!this.form.type) return;
      const r = await this.$request({
        url: this.$api.listAgentToolsInputAndOutput,
        data: {
          type: this.form.type,
          offset: 0,
          limit: 9999999,
        },
      });
      this.toolParam = r.tool_param || [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';
@import '@/styles/element/form.scss';
@import '@/styles/element/radio.scss';
@import '@/styles/element/checkbox.scss';
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/tag.scss';
@import '@/styles/element/datapicker.scss';

.container {
  .row {
    margin-bottom: 8px;
    display: flex;
    .title {
      color: #98a2b2;
    }
    .text {
      flex: 1;
    }
  }
}
.drawer-footer-btn {
  margin-left: 8px;
}
.json-editor {
  background: #e5eaf2;
  height: 200px;
  overflow-x: scroll;
  overflow-y: scroll;
  cursor: pointer;
}
.select {
  width: 100%;
}
.form-title{
  padding-bottom: 4px;
  color: #384050;
  font-weight: 400;
  line-height: 32px;
}
.wrap {
  ::v-deep {
    .el-card {
      margin-bottom: 16px;
    }
    .el-card__body {
      padding-bottom: 12px;
    }
  }
}
.mini-button {
  min-height: auto;
}
</style>
